import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  DialogContainer: {
    backgroundColor: theme.vars.palette.transparent.a25,
    'MuiDialog-container': {
      backgroundColor: theme.vars.palette.background.elevation1
    }
  },
  syncAccordion: {
    backgroundColor: theme.vars.palette.background.elevation2,
    '& .MuiTableContainer-root': {
      backgroundColor: theme.vars.palette.background.elevation2
    }
  },
  syncAccordionGroup: {
    padding: '.5rem 1.5rem',
    backgroundColor: theme.vars.palette.border.light
  },
  DiscriptionFormStyle: {
    '& textarea': {
      padding: '0!important'
    }
  },
  dFlex: {
    display: 'flex'
  },
  fullWidth: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0 .25rem .25rem 0'
    }
  },
  activationFeild: {
    width: '100%',
    '& fieldset': {
      borderRadius: '.25rem 0 0 .25rem'
    }
  },
  syncAccordionContainer: {
    '& div:not(:first-of-type)': {
      backgroundColor: theme.vars.palette.background.elevation2
    }
  },
  warningColor: {
    color: theme.vars.palette.warning.main
  },
  infoColor: {
    color: theme.vars.palette.info.main
  },
  errorColor: {
    color: theme.vars.palette.error.main
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem'
  },
  syncInfo: {
    backgroundColor: theme.vars.palette.transparent.a5,
    borderRadius: '.5rem',
    padding: '1.5rem'
  },
  deviceStatusChipAlign: {
    marginLeft: '0.5rem'
  },
  deviceCheckboxAlign: {
    position: 'absolute',
    right: '0'
  }
}));

export default useStyles;
